import "../../assets/NoMessages.css";
import { jsx as s, jsxs as o } from "react/jsx-runtime";
const a = "_noMessages_al8pp_1", t = "_noMessages__container_al8pp_7", e = {
  noMessages: a,
  noMessages__container: t
}, c = "You haven't exchanged messages with this client", r = "Start the conversation below", g = ({ participantType: n }) => /* @__PURE__ */ s("div", { className: e.noMessages, children: /* @__PURE__ */ o("section", { className: e.noMessages__container, children: [
  /* @__PURE__ */ s("h2", { children: "No messages" }),
  /* @__PURE__ */ s("p", { children: n === "provider" ? c : r })
] }) });
export {
  g as NoMessages,
  r as PATIENT_TEXT,
  c as PROVIDER_TEXT
};
